<template>
  <canvas ref="barChart"></canvas>
</template>

<script setup>
import {defineProps,onMounted, ref} from "vue";
import Chart from "chart.js/auto";
import {useApiStore} from "@/stores/ApiStore";
const apiDataStore = useApiStore();

let props = defineProps({
  isCurrency: Boolean,
  source: String,
  style: Object,
  labels: Array,
  values: Array,
  treeLabels: Array,
  colorPalette: Object,
  subject: String,
  type: String
})

let barChart = ref(null);
let chart = ref(null);
onMounted (  () => {
  let data;
  if (props.isCurrency)
  {
    data = divideToCurrency(props.values)
  }
  else {
    data = props.values
  }
  if (props.type === 'TOP_CATEGORIES' || props.type === 'TOP_BRANDS'){
    chart.value = new Chart(barChart.value, fillDataLabelsAbove(data,props.labels, props.treeLabels, props.colorPalette.barGraphPrimary));
  }else{
    chart.value = new Chart(barChart.value, fillData(data,props.labels, props.treeLabels, props.colorPalette.barGraphPrimary));
  }

})

function divideToCurrency(list)
{
  let res = [];
  list.forEach(el =>
  {
    res.push(el/100)
  })
  return res;
}

function truncateLabels(labels)
{
  let newLabels = [];
  labels.forEach(lbl => {
    if(lbl.length > 10)
    {
      newLabels.push(lbl.substring(0,7) + '...');
    }
    else
    {
      newLabels.push(lbl);
    }
  })
  return newLabels;
}

function customTooltip(tree)
{
  let res = ""
  let divider = ">"
  let length = tree.length;
  let position = 0
  tree.forEach(entry => {
    if(position === length-1){
      res += divider + " "+ entry + ""

    }else{
      res += divider + " "+ entry + " \n"
    }
    divider += ">";
    position += 1;
  })
  return res
}

const formatter = new Intl.NumberFormat(apiDataStore.getLang, {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2
});

function fillData(data,labels, treeLabels,primaryBarColor) {
  return {
    type: "bar",
    data: {
      labels: truncateLabels(labels),
      datasets: [
        {
          data: data,
          barThickness: 25,
          borderDash: [5, 5],
          backgroundColor: primaryBarColor,
          borderRadius: 8,
        }
      ]
    },
    options: {
      animation: false,
      maintainAspectRatio: false,
      responsive: true,
      indexAxis: 'y',
      layout: {
        padding: {
          left: 0,
          right: 4,
          top: 0,
          bottom: 0
        }
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          displayColors: false,
          titleFont: {
            weight: 'normal'
          },
          bodyFont: {
            weight: 'bold'
          },
          xAlign: 'center',
          yAlign: 'top',
          callbacks: {
            title: function (tooltipItem){
              if (treeLabels){
                return "";
              } else{
                return labels[tooltipItem[0].dataIndex]
              }
            },
            afterTitle: function (tooltipItem){
              if (treeLabels)
              {
                return customTooltip(treeLabels[tooltipItem[0].dataIndex] );
              }
            },
            label: function(tooltipItems) {
              if (props.isCurrency)
              {
                return formatter.format(tooltipItems.raw);
              }
              else
              {
                return tooltipItems.raw +" "+ props.subject
              }
            },
          }
        }
      },
      scales: {
        y: {
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks:{
            crossAlign: 'start',
            display: props.style.verticalLabels
          },
          afterSetDimensions(scale) {
            scale.maxWidth = 80;
            // scale.maxWidth = barChart.value.clientWidth;
          },
        },
        x: {
          grid: {
            borderDash: [5,5]
          }
        },
      },
    }
  };
}

function fillDataLabelsAbove(data,labels, treeLabels,primaryBarColor) {
  return {
    type: "bar",
    data: {
      labels: truncateLabels(labels),
      datasets: [
        {
          data: data,
          barThickness: 20,
          borderDash: [5, 5],
          backgroundColor: primaryBarColor,
          borderRadius: 8,
        }
      ]
    },
    options: {
      animation: false,
      maintainAspectRatio: false,
      responsive: true,
      indexAxis: 'y',
      layout: {
        padding: {
          left: 0,
          right: 4,
          top: 0,
          bottom: 0
        }
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          displayColors: false,
          titleFont: {
            weight: 'normal'
          },
          bodyFont: {
            weight: 'bold'
          },
          callbacks: {
            title: function (tooltipItem){
              if (treeLabels && treeLabels.length>0){
                return "";
              } else{
                return labels[tooltipItem[0].dataIndex]
              }
            },
            afterTitle: function (tooltipItem){
              if (treeLabels && treeLabels.length>0)
              {
                return customTooltip(treeLabels[tooltipItem[0].dataIndex] );
              }
            },
            label: function(tooltipItems) {
              if (props.isCurrency)
              {
                return formatter.format(tooltipItems.raw);
              }
              else
              {
                return tooltipItems.raw +" "+ props.subject
              }
            },
          }

        }
      },
      scales: {
        y: {
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks:{
            crossAlign: 'start',
            display: false
          },
          afterSetDimensions(scale) {
            scale.maxWidth = 80;
          },
        },
        x: {
          grid: {
            borderDash: [5,5]
          },
          ticks:{
            maxRotation: 0,
          }
        },
      },
    }
  };
}

// eslint-disable-next-line no-undef
defineExpose({
  changeData
});

function changeData( values, labels, treeLabels,barColor)
{
  chart.value.destroy()
  let data;
  if (props.isCurrency)
  {
    data = divideToCurrency(values)
  }
  else {
    data = values
  }
  chart.value = new Chart(barChart.value, fillData(data,labels,treeLabels,barColor));
  return true
}
</script>
